<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['order.no']" :placeholder="$t('business.label.orderNo')" @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['orderType.name']" :placeholder="$t('business.label.orderType')" readOnly @dblclick="()=>this.$refs.orderTypeModal.open({available:true,operationType:1,refundable:false})" @pressEnter="getData" @search="()=>this.$refs.orderTypeModal.open({available:true,operationType:1,refundable:false})"/>
    </a-space>
    <order-type-modal ref="orderTypeModal" @change="(orderType)=>{
      if(orderType.length>0){
        query['orderTypeId'] = orderType[0].id
        query['orderType.name']=orderType[0].name
      }else {
        query['orderTypeId'] = null
        query['orderType.name']= ''
      }
    }"/>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="checkbox" width="50"/>
      <vxe-column field="asnOrder.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="asnOrder.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="asnOrder.orderStatus" title="business.label.orderStatus" width="100">
        <template slot-scope="{ row }">{{orderStatusData.length === 0 ? row.asnOrder.orderStatus : orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name}}</template>
      </vxe-column>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="asnDetail.quantity" title="business.label.quantity"/>
      <vxe-column field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity"/>
      <vxe-column field="asnDetail.rejectedQuantity" title="business.label.rejectedQuantity"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import moment from 'moment'

export default {
  name: 'ReceivingCloseTable',
  components: {
    OrderTypeModal
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'order.no': '',
        'orderType.name': '',
        'orderTypeId': null
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  props: {
    orderStatusData: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    moment,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    reset() {
      this.query = {
        'order.no': '',
        'orderType.name': '',
        'orderTypeId': null
      }
      this.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      findAll('receivingCloseListFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    dblclick(row) {
      this.$emit('dblclick', row)
    },
    close() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        return this.$message.warning('请先选择需要关闭的单据')
      }
      let that = this
      this.$confirm({
        title: '是否确认关单?',
        content: '关单之后单据将无法继续收货以及验收',
        onOk() {
          return new Promise((resolve) => {
            let args = []
            selectedRows.forEach(item => {
              args.push({ id: item.asnOrder.id })
            })
            post(Api.receivingAsnCompleteAll, { type: 'normalAsn' }, args).then(res => {
              if (res.success) {
                that.$message.success('关单成功')
                that.$emit('success')
              }
              resolve()
            })
          })
        },
        onCancel() {
        },
        centered: true
      })
    }
  }
}
</script>